/**
 * Determina si un valor de configuración (cacheado o recién obtenido) es
 * utilizable.
 *
 * El backend puede devolver ocasionalmente un cuerpo vacío o malformado (p. ej.
 * "" para /configurations/schemas, o una respuesta prefijada por output leakeado
 * de PHP que axios deja sin parsear como string). Si ese valor se cachea en
 * localStorage con TTL de 1 semana, el panel se queda atascado (formulario vacío
 * o crash "y.map is not a function") hasta que caduque. Validamos aquí para
 * ignorar la cache inservible y re-pedir a la API. Función pura y sin
 * dependencias para poder testearla de forma aislada.
 */
export function isUsableConfigData(data: any): boolean {
  if (Array.isArray(data)) {
    return data.length > 0;
  }
  if (data && typeof data === "object") {
    return Object.keys(data).length > 0;
  }
  // "", null, undefined, strings, números → no utilizable
  return false;
}

export default isUsableConfigData;
